import Vue from 'vue';
import App from './App.vue';

import "normalize.css";

// Simple event bus to pass data from control view to map view.
Vue.prototype.$eventBus = new Vue();

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#jbandApp');
